import { animate } from 'animejs';

(() => {
  const stickyCTA = document?.querySelector('.cta-sticky');
  const section = document?.querySelector('.cta-section');
  const triggerSection = document?.querySelector('.what-makes-us-special');
  let morphed = false;
  let buttonVisible = false;
  let lastScrollY = window.scrollY;

  if (!stickyCTA || !section || !triggerSection) return;

  // Ensure initial state for section and sticky button
  section.style.transform = 'scaleX(0)';
  section.style.transformOrigin = 'right';
  section.style.opacity = '0';
  stickyCTA.style.right = '-120px'; // Start hidden
  stickyCTA.style.opacity = '0';

  function showStickyButton() {
    if (!buttonVisible) {
      buttonVisible = true;
      animate(stickyCTA, {
        right: '30px',
        opacity: 1,
        duration: 400,
        easing: 'easeInOutQuad',
      });
    }
  }

  function hideStickyButton() {
    if (buttonVisible) {
      buttonVisible = false;
      animate(stickyCTA, {
        right: '-120px',
        opacity: 0,
        duration: 400,
        easing: 'easeInOutQuad',
      });
    }
  }

  function unfurlSection() {
    // Step 1: Animate button off-screen to the right and fade out
    buttonVisible = false;
    animate(stickyCTA, {
      right: '-120px', // Move fully off-screen
      opacity: 0,
      duration: 400,
      easing: 'easeInOutQuad',
      complete: () => {
        // Step 2: Unfurl the section after button is gone
        animate(section, {
          scaleX: 1,
          opacity: 1,
          duration: 1000,
          easing: 'easeInOutQuad',
        });
      },
    });
  }

  function hideSection() {
    // Hide section first
    animate(section, {
      scaleX: 0,
      opacity: 0,
      duration: 700,
      easing: 'easeInOutQuad',
      complete: () => {
        // Then bring button back in from the right
        buttonVisible = true;
        animate(stickyCTA, {
          right: '30px',
          opacity: 1,
          duration: 1000,
          easing: 'easeInOutQuad',
        });
      },
    });
  }

  // Observer for the trigger section - handles showing/hiding the button
  const triggerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < lastScrollY;
      lastScrollY = currentScrollY;

      if (entry.isIntersecting) {
        showStickyButton();
      } else if (isScrollingUp) {
        // Only hide when scrolling up past the trigger section
        hideStickyButton();
      }
    });
  }, {
    threshold: 0,
  });

  // Observer for the CTA section - handles both showing/hiding the button and section
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !morphed) {
        unfurlSection();
        morphed = true;
      } else if (!entry.isIntersecting && morphed) {
        hideSection();
        morphed = false;
      }
    });
  }, {
    threshold: 0,
  });

  triggerObserver.observe(triggerSection);
  sectionObserver.observe(section);
})();
